import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-211b8094")

_pushScopeId("data-v-211b8094")
const _hoisted_1 = { class: "ui__ecuDetail_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ECU检测 ")
const _hoisted_4 = { class: "ui__baseInfo_main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ecu-introduce" }, [
  /*#__PURE__*/_createVNode("div", { class: "ecu-introduce-title" }, " 什么是ECU检测？ "),
  /*#__PURE__*/_createVNode("div", { class: "ecu-introduce-text" }, " 通过诊断仪与汽车OBD接口连接读取行车电脑的数据。这项检测可以读取的数据包括发动机燃油系统、排放控制系统、氧传感器、三元催化器，电控系统以及变速箱等核心零部件的工况，重点是ECU会记录下各个系统在运行中是否出现过故障，一旦有故障信息则会被保留在系统中。 ")
], -1)
const _hoisted_6 = { class: "ecu-title" }
const _hoisted_7 = { class: "ecu-title-left" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 车辆信息")
const _hoisted_9 = { class: "vin-text" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title_line" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-right" }, null, -1)
const _hoisted_12 = { class: "ecu-content-base" }
const _hoisted_13 = { class: "ui_content_item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 车牌号码 ")
const _hoisted_15 = { class: "ui_content_item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 车辆品牌 ")
const _hoisted_17 = { class: "ui_content_item" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 车辆年款 ")
const _hoisted_19 = { class: "ui_content_item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 车型名称 ")
const _hoisted_21 = { class: "ui_content_item" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 行驶里程 ")
const _hoisted_23 = { class: "ui_content_item" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 诊断时间 ")
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "ui__line" }, null, -1)
const _hoisted_26 = { class: "ui__check_items" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "ecu-items-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "ecu-items-title-left" }, [
    /*#__PURE__*/_createTextVNode(" ECU检测项 "),
    /*#__PURE__*/_createVNode("div", { class: "title_line" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ecu-title-right" })
], -1)
const _hoisted_28 = { class: "ui__abnormal_main" }
const _hoisted_29 = { class: "ecu-title" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
  /*#__PURE__*/_createVNode("span", null, "异常项")
], -1)
const _hoisted_31 = { class: "ecu-content-abnormal" }
const _hoisted_32 = { class: "ui__abnormal_list_item_flex" }
const _hoisted_33 = { class: "ui__abnormal_list_item_left" }
const _hoisted_34 = { class: "ui__abnormal_list_checkbox" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", null, "｜", -1)
const _hoisted_36 = { class: "ui__abnormal_list_item_center" }
const _hoisted_37 = { class: "ui__abnormal_list_checkitem" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "ui__abnormal_list_item_right" }, " 异常 ", -1)
const _hoisted_39 = {
  key: 0,
  class: "ui__abnormal_list_box"
}
const _hoisted_40 = { class: "ui__abnormal_code" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "ui__abnormal_code_left" }, "故障码", -1)
const _hoisted_42 = { class: "ui__abnormal_code_right" }
const _hoisted_43 = { class: "ui__abnormal_des" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "ui__abnormal_des_left" }, "故障描述", -1)
const _hoisted_45 = { class: "ui__abnormal_des_right" }
const _hoisted_46 = { class: "ui__normal_main" }
const _hoisted_47 = { class: "ecu-title" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
  /*#__PURE__*/_createVNode("span", null, "正常项")
], -1)
const _hoisted_49 = { class: "ecu-content-normal" }
const _hoisted_50 = { class: "ui__normal_list_item_flex" }
const _hoisted_51 = { class: "ui__normal_list_item_left" }
const _hoisted_52 = { class: "ui__normal_list_checkbox" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "｜", -1)
const _hoisted_54 = { class: "ui__normal_list_item_center" }
const _hoisted_55 = { class: "ui__normal_list_checkitem" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "ui__normal_list_item_right" }, " 正常 ", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "ui__line" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "ui__reminder_main" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__reminder_title" }, " 温馨提示 "),
  /*#__PURE__*/_createVNode("div", { class: "ui__reminder_text" }, " 本检测所展示的车辆运行数据均为静态数据，信息仅供参考，腾发不对由此产生的任何事故和故障承担责任。 ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ecuDetail-header",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("span", _hoisted_9, "VIN码：" + _toDisplayString(_ctx.state.ecuBaseInfo.vin), 1),
          _hoisted_10
        ]),
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.license), 1)
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.brand), 1)
        ]),
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.year), 1)
        ]),
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.modelName), 1)
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.mile), 1)
        ]),
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.checkTime), 1)
        ])
      ])
    ]),
    _hoisted_25,
    _createVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode("div", _hoisted_28, [
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("div", {
            class: "ecu-title-right",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeAbnormal && _ctx.changeAbnormal(...args)))
          }, [
            _createVNode("img", {
              class: "ui__abnormal_icon",
              src: require('@/assets/toc/ecu-abnormal.png')
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.state.abnormalItemCount) + "项", 1),
            _createVNode("img", {
              class: "ui__show_icon",
              src: require('@/assets/toc/ecu-down.png')
            }, null, 8, ["src"])
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_31, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.abnormalList, (itemfather) => {
            return (_openBlock(), _createBlock("div", {
              class: "ui__abnormal_list_item",
              key: itemfather.index
            }, [
              _createVNode("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  _createVNode("p", _hoisted_34, _toDisplayString(itemfather.systemType), 1),
                  _hoisted_35
                ]),
                _createVNode("div", _hoisted_36, [
                  _createVNode("p", _hoisted_37, _toDisplayString(itemfather.systemName), 1)
                ]),
                _hoisted_38
              ]),
              (itemfather.items && itemfather.items.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_39, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemfather.items, (itemchild) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "ui__abnormal_list_box_item",
                        key: itemchild.faultCode
                      }, [
                        _createVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode("div", _hoisted_42, _toDisplayString(itemchild.faultCode), 1)
                        ]),
                        _createVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createVNode("div", _hoisted_45, _toDisplayString(itemchild.faultDesc) + "字", 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.state.isAbnormal]
        ])
      ]),
      _createVNode("div", _hoisted_46, [
        _createVNode("div", _hoisted_47, [
          _hoisted_48,
          _createVNode("div", {
            class: "ecu-title-right",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeNormal && _ctx.changeNormal(...args)))
          }, [
            _createVNode("img", {
              class: "ui__normal_icon",
              src: require('@/assets/toc/ecu-normal.png')
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.state.normalItemCount) + "项", 1),
            _createVNode("img", {
              class: "ui__show_icon",
              src: require('@/assets/toc/ecu-down.png')
            }, null, 8, ["src"])
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_49, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.normalList, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "ui__normal_list_item",
              key: item.index
            }, [
              _createVNode("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, [
                  _createVNode("p", _hoisted_52, _toDisplayString(item.systemType), 1),
                  _hoisted_53
                ]),
                _createVNode("div", _hoisted_54, [
                  _createVNode("p", _hoisted_55, _toDisplayString(item.systemName), 1)
                ]),
                _hoisted_56
              ])
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.state.isNormal]
        ])
      ])
    ]),
    _hoisted_57,
    _hoisted_58
  ]))
})